import React from 'react'
import RedirectTemplate from 'src/components/template/redirect'

export default (props) => {
  return <RedirectTemplate location={props.location} destination="/root-sports/kraken/" />
}
